export const TAG_SIZES = {
  sm: 'sm',
  md: 'md',
};

export const TAG_APPEARANCES = {
  info: 'info',
  success: 'success',
  warning: 'warning',
  error: 'error',
  gray: 'gray',
  transparent: 'transparent',
  purple: 'purple',
  aqua: 'aqua',
  orange: 'orange',
};
